const PAGE_ALERTS_SEEN_SESSION_KEY = 'nobrinde:page-alerts-seen'

export function hasSeenPageAlertsInSession(): boolean {
  if (typeof sessionStorage === 'undefined') return false
  return sessionStorage.getItem(PAGE_ALERTS_SEEN_SESSION_KEY) === '1'
}

export function markPageAlertsSeenInSession(): void {
  if (typeof sessionStorage === 'undefined') return
  sessionStorage.setItem(PAGE_ALERTS_SEEN_SESSION_KEY, '1')
}
